import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api.js";

// Centralisation des routes API
const API_ROUTES = {
    GET_SELLER_REQUEST: `/api/seller/seller_request_get`,
    GET_SELLER_INFOS_BY_SELLERID: `/api/seller/seller_infos_get`,
    SELLER_STATUS_UPDATE: `/api/seller/update/seller_status`,
    GET_ACTIVE_SELLERS: `/api/seller/get_active_sellers`,
    CREATE_STRIPE_CONNECT_ACCOUNT: `/api/seller/payment/create_stripe_account`,
    ACTIVE_STRIPE_CONNECT_ACCOUNT: `/api/seller/payment/active_stripe_account`,
    LOGOUT_SELLER: '/api/logout',
    REQUESTSELLERSUBSCRIPTION: "/api/seller/subscription/request",
    APPROUVE_SELLER_SUBSCRIPTION:"/api/admin/subscription/approve",
    REJECT_SELLER_SUBSCRIPTION:"/api/admin/subscription/reject"

};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) => error.response?.data.message || error.message;

export const get_seller_request = createAsyncThunk(
    "seller/get_seller_request",
    async ({ searchValue, parPage, page }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(
                `${API_ROUTES.GET_SELLER_REQUEST}?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
                { withCredentials: true }
            );
          //  console.log("Réponse de l'API :", data);
          return fulfillWithValue(data);
        } catch (error) {
           // return rejectWithValue(error.response?.data?.message || "Une erreur inattendue est survenue");
           return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const get_seller_infos_by_sellerId = createAsyncThunk(
    "seller/get_seller_infos_by_sellerId",
    async (sellerId, { rejectWithValue, fulfillWithValue }) => {
        //console.log('seller Id', sellerId);
        try {
            const { data } = await api.get(`${API_ROUTES.GET_SELLER_INFOS_BY_SELLERID}/${sellerId}`,
                { withCredentials: true }
            );
           // console.log("Réponse de l'API seller infos :", data);
           return fulfillWithValue(data);
        } catch (error) {
           // return rejectWithValue(error.response?.data?.message || "Une erreur inattendue est survenue" );
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const seller_status_update = createAsyncThunk(
    "seller/seller_status_update ",
    async (info, { rejectWithValue ,fulfillWithValue}) => {
       // console.log('seller Info', info);
        try {
            const { data } = await api.post(API_ROUTES.SELLER_STATUS_UPDATE, info,
                { withCredentials: true }
            );
           // console.log("Réponse de l'API seller infos :", data);
           return fulfillWithValue(data);
        } catch (error) {
            //return rejectWithValue(error.response?.data?.message || "Une erreur inattendue est survenue");
            return rejectWithValue(getErrorMessage(error));
        }
    }
);
///////////////////////////////////////////

/** Admin → approuver */
export const approveSellerSubscription = createAsyncThunk(
  "admin/approveSubscription",
  async ({ subscriptionId }, { rejectWithValue, fulfillWithValue}) => {
    //console.log('subscription Id ', subscriptionId)
    try {
    //console.log('subscription Id ', subscriptionId)
      const { data } = await api.post(API_ROUTES.APPROUVE_SELLER_SUBSCRIPTION, { subscriptionId });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

/** Admin → rejeter */
export const rejectSellerSubscription = createAsyncThunk(
  "admin/rejectSubscription",
  async ({ subscriptionId , note }, { rejectWithValue }) => {
    try {
      const { data } = await api.post(API_ROUTES.REJECT_SELLER_SUBSCRIPTION, {
        subscriptionId ,
        note,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

//////////////////////////////////////////////////////////////////////
export const requestSellerSubscription = createAsyncThunk(
  "seller/requestSellerSubscription",
  async ({ plan }, { rejectWithValue }) => {
    try {
      const { data } = await api.post(
        API_ROUTES.REQUESTSELLERSUBSCRIPTION,
        { plan },
        { withCredentials: true }
      );

      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Erreur de demande"
      );
    }
  }
);
/////////////////////////////////////////////////////////////////////////////////////////
export const get_active_sellers = createAsyncThunk(
    "seller/get_active_sellers",
    async ({ searchValue, parPage, page, status}, { rejectWithValue, fulfillWithValue }) => {
       // console.log('status', status);
        try {
            const { data } = await api.get(
                `${API_ROUTES.GET_ACTIVE_SELLERS}?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
                {
                    params: { status }, // Add status as a query parameter if needed
                    withCredentials: true
                }
            );
           // console.log("Réponse de l'API seller infos :", data);
           return fulfillWithValue(data);
        } catch (error) {
        //return rejectWithValue(error.response?.data?.message || "Une erreur inattendue est survenue");
        return rejectWithValue(getErrorMessage(error));
        }
    }
);

// Action for deleting seller
export const delete_seller = createAsyncThunk(
    "seller/delete_seller",
    async (sellerId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.delete(`${API_ROUTES.DELETE_SELLER}/${sellerId}`, { withCredentials: true });
           // console.log("API Response seller delete:", data); // Log the API response
            return fulfillWithValue(data); // Renvoyer la réponse complète
        } catch (error) {
           //console.error("Error deleting product:", error);
           // return rejectWithValue(error.response?.data?.message || error.message);
           return rejectWithValue(getErrorMessage(error));
        }
    }
);

// create stripe account 
/*
export const create_stripe_connect_account = createAsyncThunk(
    "seller/create_stripe_connect_account",
    async () => {
        try {
            const { data :{url} } = await api.get(`/seller/payment/create_stripe_account`, { withCredentials: true });
           console.log("API Response create_stripe_connect_account:", url); // Log the API response
           window.location.href = url;
            //return fulfillWithValue(data); // Renvoyer la réponse complète
        } catch (error) {
           console.error("Error creating stripe_connect_account", error);
          //return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);
*/
// create stripe account 
export const create_stripe_connect_account = createAsyncThunk(
    "seller/create_stripe_connect_account",
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(API_ROUTES.CREATE_STRIPE_CONNECT_ACCOUNT, { withCredentials: true });
           //console.log("API Response create_stripe_connect_account:", data.url.url); // Log the API response
           window.location.href = data.url.url;
            return fulfillWithValue(data); // Renvoyer la réponse complète
        } catch (error) {
          // console.error("Error creating stripe_connect_account", error);
         // return rejectWithValue(error.response?.data?.message || error.message);
         return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const active_stripe_connect_account = createAsyncThunk(
    "seller/active_stripe_connect_account",
    async (activeCode,{ rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`${API_ROUTES.ACTIVE_STRIPE_CONNECT_ACCOUNT}/${activeCode}`, { withCredentials: true });
           //console.log("API Response active stripe_connect_account:",data); // Log the API response
            return fulfillWithValue(data); // Renvoyer la réponse complète
        } catch (error) {
        //console.error("Error activating stripe_connect_account", error);
         // return rejectWithValue(error.response?.data?.message || error.message);
         return rejectWithValue(getErrorMessage(error));
        }
    }
);
/*
// Nouveau logout silencieux
export const logoutSellerSilently = createAsyncThunk(
    "auth/logoutSilently",
    async (_, { rejectWithValue, fulfillWithValue }) => {
      try {
         await api.get(API_ROUTES.LOGOUT, { withCredentials: true });
  
        // On ne fait PAS de redirection ici
        localStorage.removeItem("customerToken");
  
        return fulfillWithValue(); // On peut retourner un message ou rien
      } catch (error) {
        return rejectWithValue(getErrorMessage(error));
      }
    }
  );
*/

  export const logoutSellerSilently = createAsyncThunk(
    "seller/logoutSellerSilently",
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(API_ROUTES.LOGOUT_SELLER, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const sellerReducer = createSlice({
    name: "seller",
    initialState: {
        successMessage: "",
        errorMessage: "",
        loadingSellers: false,
        loadingSellerInfos: false,
        sellers: [],
        totalSellers: 0,
        sellerInfos: {},
        requestSubscriptionLoading: false,
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = "";
            state.successMessage = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(get_seller_request.pending, (state) => {
                state.loadingSellers = true;
                state.errorMessage = "";
            })
            .addCase(get_seller_request.fulfilled, (state, action) => {
                state.loadingSellers = false;
                state.sellers = action.payload?.sellers || [];
                state.totalSellers = action.payload?.totalSellers || 0;
            })
            .addCase(get_seller_request.rejected, (state, action) => {
                state.loadingSellers = false;
                state.errorMessage = action.payload;
            })
            .addCase(get_seller_infos_by_sellerId.pending, (state) => {
                state.loadingSellerInfos = true;
                state.errorMessage = "";
            })
            .addCase(get_seller_infos_by_sellerId.fulfilled, (state, action) => {
               // console.log("Action payload :", action.payload);
                state.loadingSellerInfos = false;
                state.successMessage = action.payload.message || " Informations du vendeur récupérées avec succès";
                state.sellerInfos = action.payload.seller || {};
            })
            .addCase(get_seller_infos_by_sellerId.rejected, (state, action) => {
                state.loadingSellerInfos = false;
                state.errorMessage = action.payload;
            })
            .addCase(seller_status_update.pending, (state) => {
                state.loadingSellerInfos = true;
                state.errorMessage = "";
            } )
            .addCase(seller_status_update.fulfilled, (state, action) => {
                state.loadingSellerInfos = false
                state.successMessage = action.payload.message || " Statut du vendeur mis à jour avec succès"
                state.sellerInfos = action.payload.seller
            })
            .addCase(get_active_sellers.rejected, (state, action) => {
                state.loadingSellers = false;
                state.errorMessage = action.payload;
            })
            .addCase(get_active_sellers.pending, (state) => {
                state.loadingSellers = true;
                state.errorMessage = "";
            })
            .addCase(get_active_sellers.fulfilled, (state, action) => {
                state.loadingSellers = false;
                state.sellers = action.payload?.sellers || [];
                state.totalSellers = action.payload?.total_active_sellers|| 0;
            })
            .addCase(delete_seller.rejected, (state, action) => {
                state.loadingSellers = false;
                state.errorMessage = action.payload;
            })
            .addCase(delete_seller.pending, (state) => {
                state.loadingSellers = true;
                state.errorMessage = "";
            })
            .addCase(delete_seller.fulfilled, (state, action) => {
                state.loadingSellers = false;
                state.successMessage = action.payload.message || " Vendeur supprimé avec succès";
                state.sellers = state.sellers.filter((seller) => seller.id !== action.payload.sellerId);
                state.totalSellers = state.totalSellers - 1;
            })
            .addCase(active_stripe_connect_account.rejected, (state, action) => {
                state.loadingSellerInfos = false;
                state.errorMessage = action.payload;
            })
            .addCase(active_stripe_connect_account.pending, (state) => {
                state.loadingSellerInfos = true;
                state.errorMessage = "";
            })
            .addCase(active_stripe_connect_account.fulfilled, (state, action) => {
                state.loadingSellerInfos = false;
                state.successMessage = action.payload.message || " Compte Stripe connecté avec succès";
            })

            .addCase(logoutSellerSilently.fulfilled, (state) => {
                state.loggedOut = true; // 🆕
                state.isAuthenticated = false;
                state.userInfo = {};
                state.role = '';
                state.successMessage = 'Déconnecté avec succès';
            })
            .addCase(logoutSellerSilently.rejected, (state, action) => {
                state.errorMessage = action.payload || "Erreur lors de la déconnexion";
            })
///////////////////////////////////////////////////////////
            .addCase(requestSellerSubscription.pending, (state) => {
             state.requestSubscriptionLoading = true;
            })

            .addCase(requestSellerSubscription.fulfilled, (state, action) => {
                state.requestSubscriptionLoading = false;
                state.successMessage = action.payload.message;

                if (state.sellerInfo) {
                    state.sellerInfo.subscriptionRequest =
                    action.payload.subscriptionRequest;
                }
            })

            .addCase(requestSellerSubscription.rejected, (state, action) => {
            state.requestSubscriptionLoading = false;
            state.errorMessage = action.payload;
            })

///////////////////////////////////////////////////////////////////////////////
         
            .addCase(approveSellerSubscription.fulfilled, (state, action) => {
                state.successMessage = action.payload.message;
            })

            .addCase(rejectSellerSubscription.fulfilled, (state, action) => {
                state.successMessage = action.payload.message;
            });

                },
            });

export const { messageClear } = sellerReducer.actions;
export default sellerReducer.reducer;
